import "./App.css";
import "./index.css";
import { Routes, Route } from "react-router-dom";
import StaticHomePage from "./StaticHomePage";
import TeamPage from "./Team";
import Navbar from "./components/Navbar";
import ProjectInikaPrivacyPolicy from "./components/provacy-policy";
import ProjectInikaEULA from "./components/end-user";
import ProjectInikaPrivacyPolicyIOS from "./components/privacy-policy-ios";
import PinterestPrivacyPolicy from "./components/PrivacyPolicyPinterest";
import SMSPrivPolicy from "./components/SMSPrivPolicy";
import MetaPrivacyPolicy from "./components/MetaPrivacyPolicy";

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <Navbar />
      <main>
        {" "}
        {/* Add padding top to account for fixed navbar */}
        <Routes>
          <Route path="/" element={<StaticHomePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/features" element={<ComingSoon title="Features" />} />
          <Route path="/partners" element={<ComingSoon title="Partners" />} />
          <Route
            path="/privacy-policy-quickbooks"
            element={<ProjectInikaPrivacyPolicy />}
          />
          <Route
            path="/privacy-policy-ios"
            element={<ProjectInikaPrivacyPolicyIOS />}
          />
          <Route
            path="/privacy-policy-pinterest"
            element={<PinterestPrivacyPolicy />}
          />
          <Route path="/sms-privacy-policy" element={<SMSPrivPolicy />} />
          <Route path="/privacy-policy-meta" element={<MetaPrivacyPolicy />} />
          <Route
            path="/end-user-agreement-quickbooks"
            element={<ProjectInikaEULA />}
          />
        </Routes>
      </main>
    </div>
  );
}

// Temporary component for routes under construction
const ComingSoon = ({ title }) => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-4">{title}</h1>
      <p className="text-xl">Coming Soon</p>
    </div>
  </div>
);

export default App;
